import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useAlert } from "../components/AlertContext";

interface BoardMember {
  name: string;
  role: string;
  mail: string;
  img_url: string;
  isActive?: boolean;
}

const MemberCard: React.FC<BoardMember> = ({
  name,
  role,
  mail,
  img_url,
  isActive = false,
}) => {
  const { showAlert } = useAlert();

  const handleCopyEmail = () => {
    navigator.clipboard
      .writeText(mail)
      .then(() => {
        showAlert("success", "Email copied to clipboard!");
      })
      .catch(() => {
        showAlert("error", "Failed to copy email!");
      });
  };

  return (
    <div
      className={`bg-[#1c1c3e] text-white rounded-lg shadow-md p-4 w-full max-w-xs mx-auto ${isActive ? "hidden" : ""}`}
    >
      <div className="w-48 h-48 relative overflow-hidden mx-auto rounded-lg mb-3">
        <img
          src={img_url}
          alt={name}
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-semibold mb-1">{name}</h3>
        <p className="font-bold mb-1">{role}</p>

        <button
          onClick={handleCopyEmail}
          className="text-blue-400 hover:underline"
        >
          <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
        </button>
      </div>
    </div>
  );
};

export default MemberCard;
